import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BoxOfferDropInIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 10.749C21.7298 8.28571 20.5598 6.00879 18.7144 4.35479C16.869 2.7008 14.4781 1.78613 12 1.78613C9.52188 1.78613 7.13095 2.7008 5.28558 4.35479C3.44021 6.00879 2.27025 8.28571 2 10.749M22 10.749C22 10.749 20.4585 10.5633 19.5 10.749C18.4596 10.9506 18.0509 11.668 17 11.8042M22 10.749L12 22.2138M2 10.749C2 10.749 3.54152 10.5633 4.5 10.749C5.54036 10.9506 5.94908 11.668 7 11.8042M2 10.749L12 22.2138M7 11.8042C7.97543 11.9307 8.51964 11.4188 9.5 11.4984C10.5159 11.5809 10.9808 12.2478 12 12.2478C13.0192 12.2478 13.4841 11.5809 14.5 11.4984M7 11.8042L12 22.2138M17 11.8042C16.0246 11.9307 15.4804 11.4188 14.5 11.4984M17 11.8042L14.5 11.4984M17 11.8042L12 22.2138"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
